/* eslint-disable import/no-mutable-exports */
import React from 'react';
import { Center, Image } from '@chakra-ui/react';
import { TTemplate } from '@/helpers/createTemplate';
import empty from '@/assets/junglebet/images/betslip/monkey.png';

export const template: TTemplate = {
  wrapper: <Center />,
  empty: <Image src={empty} m="3" />,
};

export default template;
